import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { environment } from 'src/environments/environment';

export interface WithdrawalFeeCalculation {
  network: string;
  coin: string;
  amount: number;
  walletAddress: string;
  fee: number;
  amountAfterFee: number;
  minWithdrawal: number;
  maxWithdrawal: number;
  withdrawEnabled: boolean;
  estimatedArrivalTime?: number;
  warnings?: string[];
}

export interface WithdrawalFeeResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data: WithdrawalFeeCalculation | null;
  requestedBy?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BinanceWithdrawalFeeService {
  private baseUrl = environment.apiNest;

  constructor(
    private http: HttpClient,
    private cognitoService: CognitoService,
  ) {}

  private async getHeaders(): Promise<HttpHeaders> {
    const session = await this.cognitoService.getSession();
    if (!session?.accessToken?.jwtToken) {
      return new HttpHeaders().set('Content-Type', 'application/json');
    }

    return new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${session.accessToken.jwtToken.trim()}`);
  }

  /**
   * Calcula el fee de retiro para una wallet y monto específico
   * @param walletAddress - Dirección de la wallet TRON (TRC20)
   * @param amount - Monto en USDT a enviar
   * @returns Observable con la información del fee calculado
   */
  async calculateWithdrawalFee(
    walletAddress: string,
    amount: number,
  ): Promise<Observable<WithdrawalFeeResponse>> {
    const headers = await this.getHeaders();
    const serviceURL = `${this.baseUrl}binance/withdrawal-fee/calculate`;

    const body = {
      walletAddress,
      amount,
    };

    return new Promise((resolve) => {
      resolve(this.http.post<WithdrawalFeeResponse>(serviceURL, body, { headers }));
    });
  }

  /**
   * Obtiene el fee actual de retiro sin calcular para un monto específico
   * @returns Observable con el fee actual
   */
  async getCurrentFee(): Promise<Observable<any>> {
    const headers = await this.getHeaders();
    const serviceURL = `${this.baseUrl}binance/withdrawal-fee/current-fee`;

    return new Promise((resolve) => {
      resolve(this.http.get<any>(serviceURL, { headers }));
    });
  }

  /**
   * Obtiene información completa de la red TRC20
   * @returns Observable con información detallada de la red
   */
  async getNetworkInfo(): Promise<Observable<any>> {
    const headers = await this.getHeaders();
    const serviceURL = `${this.baseUrl}binance/withdrawal-fee/network-info`;

    return new Promise((resolve) => {
      resolve(this.http.get<any>(serviceURL, { headers }));
    });
  }
}
